import '../scss/style.scss';

/* global gcoData, jQuery */

(function ($) {
  'use strict';

  // Mobile nav toggle
  const navToggle = document.querySelector('.nav-toggle');
  const mainNav   = document.querySelector('#site-navigation');

  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      const expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
      mainNav.classList.toggle('nav-open');
    });
  }

  // Update cart count via WooCommerce fragments
  $(document.body).on('wc_fragments_refreshed added_to_cart', function () {
    const count = WC && WC.cart ? WC.cart.cart_contents_count : null;
    if (count !== null) {
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.textContent = count;
      });
    }
  });
})(jQuery);
